import React from "react";
import { useSelectedVerificationAttempt } from "../../hooks/useVerifications";
import { PageMessage } from "@picklebet/ui";
import { ReactComponent as PendingIcon } from "assets/illustrations/warning-pending.svg";
import { Typography } from "@picklebet/ui";
import NextBettingButtons from "@/features/shell/components/shared/NextBettingButtons";

import * as styles from "./Verification.module.scss";

type PendingReviewProps = {
  children: React.ReactNode;
};

const PendingReview = ({ children }: PendingReviewProps) => {
  const { attempt } = useSelectedVerificationAttempt();

  const isPendingReview =
    attempt?.attemptStatus === "PENDING_MANUAL_REVIEW" ||
    attempt?.attemptStatus === "PENDING_REVIEW";

  if (isPendingReview) {
    return (
      <PageMessage
        title={`Verification Pending`}
        image={<PendingIcon />}
        subTitle={
          <>
            <Typography
              className={styles.pageMessageText}
              variant={`body`}
              noSpacing
            >
              Verification pending review by Support, hold tight.
            </Typography>
          </>
        }
      >
        <NextBettingButtons />
      </PageMessage>
    );
  }

  return <>{children}</>;
};

export { PendingReview };
